query SpecialisationFilters {
    specialisationFilters(orderBy: {column: SORT_ORDER, order: ASC}) {
        label: title
        value: id
    }
}
